module.exports = __webpack_public_path__ + "7749cf4c98709996cdff690614fc9f3e.ttf";